import { createSelector } from 'reselect';

export const createQuotesFormSelector = createSelector(
  (state) =>
    state.workOrders.scenes.details.scenes.createQuote.ui.createQuotesForm,
  (createQuotesForm) => {
    return createQuotesForm;
  }
);

export const createQuotesModalStateSelector = createSelector(
  (state) =>
    state.workOrders.scenes.details.scenes.createQuote.ui
      .createQuotesModalState,
  (createQuotesModalState) => {
    return createQuotesModalState;
  }
);

export const getCreateQuoteForm = createSelector(
  (state) => state.workOrders.scenes.details.scenes.createQuote.data.form,
  (form) => {
    return form;
  }
);

export const getCreateQuoteShow = createSelector(
  (state) => state.workOrders.scenes.details.scenes.createQuote.ui.show,
  (show) => {
    return show;
  }
);

export const getCreateQuoteState = createSelector(
  (state) => state.workOrders.scenes.details.scenes.createQuote.ui.state,
  (edit) => {
    return edit;
  }
);

export const getValidationMessage = createSelector(
  (state) =>
    state.workOrders.scenes.details.scenes.createQuote.ui.validationMessage,
  (validationMessage) => {
    return validationMessage;
  }
);

export const getShowCounter = createSelector(
  (state) => state.workOrders.scenes.details.scenes.createQuote.ui.showCounter,
  (showCounter) => {
    return showCounter;
  }
);

export const showCreateQuotesModalSelector = createSelector(
  (state) =>
    state.workOrders.scenes.details.scenes.createQuote.ui.showCreateQuotesModal,
  (showCreateQuotesModal) => {
    return showCreateQuotesModal;
  }
);



// WEBPACK FOOTER //
// ./src/selectors/admin/work-orders/details/create-quote.js